import useDynamicPage from "@/hooks/useDynamicPage";
import { DynamicPageSeo } from "@/ui/DynamicPageSeo";
import { ContentBlocks } from "@/ui/ContentBlocks";
import { ReciteMeWidget } from "@/ui";

export default function Page({ prefix, title, seo, canonical, data }) {
  return (
    <>
      <DynamicPageSeo
        {...seo}
        title={seo?.title.length > 0 ? seo.title : title}
        canonical={seo?.canonical.length > 0 ? seo.canonical : canonical}
      />
      <ContentBlocks data={data} prefix={prefix} />
      <ReciteMeWidget />
      <script type="text/javascript" async src="https://bot.leadoo.com/bot/chat.js?code=af9d061d" />
    </>
  );
}

export async function getStaticProps() {
  const page = useDynamicPage("/");

  return {
    props: {
      prefix: `homepage`,
      title: page.title,
      seo: page.seo,
      canonical: `/`,
      data: page.content,
    },
  };
}
